import React, { useState } from 'react';
import { Form, Stack, Col, Grid, Row, IconButton, Divider, FormInstance, Table, Textarea} from 'rsuite';
import { useNavigate } from 'react-router-dom';
import PageContent from '@/components/PageContent';
import PagePreviousIcon from '@rsuite/icons/PagePrevious';
import MapToSelectPath from '@/components/MapToSelectPath';
import { ActivityInfo, ActivityProviderList, ActivityTypeList, SportTypeList } from '@/models/activity-info.model';
import { jsDateToZone } from '@/utils/date-time';
import { getHeight } from 'rsuite/esm/DOMHelper';
const { Column, HeaderCell, Cell } = Table;

interface ActivityInfoFormProps{
  formObject?: ActivityInfo;
};

const ActivityInfoForm: React.FC<ActivityInfoFormProps> = ({formObject}) => {
  
  const nav = useNavigate();
  const formRef = React.useRef<FormInstance<Record<string, any>>>(null);
  
  const [simplifiedRoute, setSimplifiedRoute] = useState<string>("");

  return (  
    <PageContent>
      <Form name='activity-info-detail' layout="vertical" fluid ref={formRef} formValue={formObject}>
        <Grid w='100%' fluid>
          <Row>
            <Col span={{xs: 24, md: 12, xl: 6}}>
              <Form.Group>
                <Form.Label>Country</Form.Label>
                <Form.Control name="country" value={formObject?.country?.name}/>
              </Form.Group>
              <Form.Group>
                <Form.Label>City</Form.Label>
                <Form.Control name="city" value={formObject?.city?.name}/>
              </Form.Group>
              <Form.Group>
                <Form.Label>Provider</Form.Label>
                <Form.Control name="provider" value={ActivityProviderList.findLast(p => p.value == formObject?.provider)?.label}/>
              </Form.Group>              
              <Form.Group>
                <Form.Label>User</Form.Label>
                <Form.Control name="user" value={`${formObject?.user.firstName} ${formObject?.user.lastName}`}/>
              </Form.Group>              
              <Form.Group>
                <Form.Label>Distance (meter)</Form.Label>
                <Form.Control name="distanceInMeter"/>
              </Form.Group>              
              <Form.Group>
                <Form.Label>Start Time</Form.Label>
                <Form.Control name="startTime" value={jsDateToZone(formObject?.startTime, formObject?.city?.ianaTimeZoneId)}/>
              </Form.Group>              
              <Form.Group>
                <Form.Label>Duration (seconds)</Form.Label>
                <Form.Control name="duration"/>
              </Form.Group>              
              <Form.Group>
                <Form.Label>Activity Type</Form.Label>
                <Form.Control name="activityType" value={ActivityTypeList.findLast(t => t.value == formObject?.activityType)?.label}/>
              </Form.Group>              
              <Form.Group>
                <Form.Label>Sport Type</Form.Label>
                <Form.Control name="sportType" value={SportTypeList.findLast(t => t.value == formObject?.sportType)?.label}/>
              </Form.Group>    
              <Form.Group>
                <Form.Label>User Provider Id</Form.Label>
                <Form.Control name="providerId"/>
              </Form.Group>
              <Form.Group>
                <Form.Label>Simplify Route</Form.Label>
                <Textarea value={simplifiedRoute} onChange={val => setSimplifiedRoute(val)} />
              </Form.Group>
            </Col>
            <Col span={{xs: 24, md: 12, xl: 6}}>
              <Form.Label>Route ({`${formObject?.route?.length ?? 0} Points`})</Form.Label>
              <Table data={formObject?.route} height={Math.max(getHeight(window) - 300, 500)}>
                <Column flexGrow={0.5} align="left" >
                  <HeaderCell>#</HeaderCell>
                  <Cell>{(rowData, i) => ((i ?? 0) + 1)}</Cell>
                </Column>
                <Column flexGrow={1} align="left" >
                  <HeaderCell>Latitude</HeaderCell>
                  <Cell dataKey="lat" />
                </Column>
                <Column flexGrow={1} align="left" >
                  <HeaderCell>Longitude</HeaderCell>
                  <Cell dataKey="lng" />
                </Column>
              </Table>              
            </Col>
            <Col span={{xs: 24, xl: 12}}>
              <Form.Label style={{ textAlign: 'center'}}>Route on the map</Form.Label>
                <MapToSelectPath
                value={simplifiedRoute ? JSON.parse(simplifiedRoute) : formObject?.route}
                defaultCenter={formObject?.city && {lat: formObject?.city?.lat, lng: formObject?.city?.lon}}
                height={`${Math.max(getHeight(window) - 300, 500)}px`}
                disabled
              />
            </Col>
          </Row>
        </Grid>
      </Form>
      <Divider />
      <Stack justifyContent="space-between">
        <IconButton icon={<PagePreviousIcon />} onClick={() => nav(-1)}>
          Back
        </IconButton>
      </Stack>
    </PageContent>
  );
};

export default ActivityInfoForm;